<template>
  <b-form-group
    label="Varsayılan Şube"
    label-for="id_branches"
  >
    <validation-provider
      #default="{ errors }"
      name="Varsayılan Şube"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_branches"
        :options="branches"
        label="title"
        :reduce="type => type.id"
        placeholder="Seçiniz"
        :clearable="false"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'BranchSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['users/dataItem']
    },
    branches() {
      return this.$store.getters['branches/dataList']
    },
  },
  created() {
    this.getDataList()
    localize('tr')
  },
  methods: {
    getDataList() {
      this.$store.dispatch('branches/getDataList', {
        select: [
          'branches.id AS id',
          'branches.title AS title',
        ],
      })
    },
  },
}
</script>
